import type { ReactNode, MouseEvent } from 'react';

import { DialogOverlay, DialogPanel } from './MobileSearchDialog.styled';

// TODO: use a real Modal instead?
type Props = {
  onClose: () => void;
  children: ReactNode;
};

export function MobileSearchDialog({ onClose, children }: Props) {
  const handleOverlayClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <DialogOverlay
      onClick={handleOverlayClick}
      data-qa-id="search-dialog-overlay"
    >
      <DialogPanel>{children}</DialogPanel>
    </DialogOverlay>
  );
}
